import { any, apiDate, boolean, optional, string, zenum, znull, zodLess, ZodLessInfer, zunion } from '@kaiizen/zod-less';
import { ApiAllOrgSettingsKeysSchema } from './ApiAllOrgSettingsSchema';

/** @deprecated */
export const ExportsDataSchema = zodLess({
  includePageNumbers: {
    value: boolean,
    type: optional(string),
    helpText: optional(string),
    helpTitleText: optional(string),
  },
  includeTaskPhotos: {
    value: boolean,
    type: optional(string),
    helpText: optional(string),
    helpTitleText: optional(string),
  },
});

/** @deprecated this was never used */
export const ScanOverviewPageDataSchema = zodLess({
  showDefaultContractorCard: {
    value: boolean,
    type: optional(string),
    helpText: optional(string),
    helpTitleText: optional(string),
  },
});

/** @deprecated */
export const ScanEditorShowTagsKebabAndMenuSchema = zodLess({
  showLineItemTagsKebabAndMenu: {
    value: boolean,
    type: optional(string),
    helpText: optional(string),
    helpTitleText: optional(string),
  },
});

/** @deprecated */
export type ExportsData = ZodLessInfer<typeof ExportsDataSchema>;
/** @deprecated */
export type ScanOverviewPageData = ZodLessInfer<typeof ScanOverviewPageDataSchema>;
/** @deprecated */
export type ScanEditorShowTagsKebabAndMenu = ZodLessInfer<typeof ScanEditorShowTagsKebabAndMenuSchema>;

export const DeprecatedOrgSettingsKeysSchema = zenum('exports', 'scanOverviewPage', 'scanEditor');
export const ApiOrgSettingsSchemaKeysSchema = zunion(DeprecatedOrgSettingsKeysSchema, ApiAllOrgSettingsKeysSchema);
export type ApiOrgSettingsKeys = ZodLessInfer<typeof ApiOrgSettingsSchemaKeysSchema>;

// Single schema for all settings - data structure varies by key
export const ApiOrgSettingsSchema = zodLess({
  id: string,
  orgId: string,
  key: ApiOrgSettingsSchemaKeysSchema,
  data: any, // Will be validated as ExportsData, ScanOverviewPageData, or ScanEditorShowTagsKebabAndMenu based on key
  logoSvg: optional(zunion(string, znull)),
  createdAt: apiDate,
  updatedAt: apiDate,
});

const READ_ONLY_FIELDS = { createdAt: true, updatedAt: true } as const;
export const ApiVivifyOrgSettingsSchema = ApiOrgSettingsSchema.omit({ ...READ_ONLY_FIELDS, id: true }).partial().required({ key: true });
export const ApiUpdateOrgSettingsSchema = ApiOrgSettingsSchema.omit({ ...READ_ONLY_FIELDS, id: true, orgId: true, key: true }).partial();

export type ApiOrgSettings = ZodLessInfer<typeof ApiOrgSettingsSchema>;
export type ApiVivifyOrgSettings = ZodLessInfer<typeof ApiVivifyOrgSettingsSchema>;
export type ApiUpdateOrgSettings = ZodLessInfer<typeof ApiUpdateOrgSettingsSchema>;

export const getOrgSettingQueryKey = (id: string) => `orgSetting/${id}`;
export const getOrgSettingsQueryKey = (token?: string | null) => `orgSettings/${token ?? 'anonymous'}`;
export const getAllOrgSettingsQueryKey = (token?: string | null) => `allOrgSettings/${token ?? 'anonymous'}`;
